<template>
  <b-modal
    title="Dodaj przedpłatę"
    cancel-title="Anuluj"
    v-model="modalShow"
    @show="resetModal"
    @hidden="resetModal"
    @ok="onSubmit"
  >
    <b-form @submit.prevent="onSubmit">
      <b-form-group class="required" label="Wysokość przedpłaty [PLN]">
        <b-form-input
          v-model="value"
          type="text"
          autocomplete="off"
          :state="$v.value.$error? false : null"
          @input="$v.value.$reset()"
          @keypress="onlyForCurrency"
        />
        <b-form-invalid-feedback>
          <div v-if="!$v.value.required">To pole jest wymagane</div>
          <div v-if="!$v.value.isCorrectDecimal">Wpisana wartość jest niepoprawna</div>
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group label="Data księgowania" class="required">
        <date-picker
          v-model="bookedDate"
          :config="options"
          language="pl"
          autocomplete="off"
          :class="{'is-invalid': $v.bookedDate.$error}"
        ></date-picker>
        <b-form-invalid-feedback v-if="!$v.bookedDate.required">To pole jest wymagane</b-form-invalid-feedback>
      </b-form-group>
    </b-form>
  </b-modal>
</template>

<script>
import { axios, eventBus } from "@/_infrastructure";
import { required } from "vuelidate/lib/validators";

function replaceCommasWithDots(value) {
  let valueString = value + "";
  return valueString.split(",").join(".");
}

const isCorrectDecimal = value => {
  let valueWithDotsString = replaceCommasWithDots(value);

  if (
    value == null ||
    (valueWithDotsString.indexOf(".") > -1 &&
      valueWithDotsString.split(".")[1].length > 2)
  ) {
    return false;
  } else if (valueWithDotsString < 0) {
    return false;
  }

  return true;
};

export default {
  data() {
    return {
      modalShow: false,
      value: null,
      bookedDate: null,
      options: {
        format: "YYYY-MM-DD HH:mm",
        locale: "pl",
        useCurrent: true
      }
    };
  },
  validations: {
    value: {
      required,
      isCorrectDecimal
    },
    bookedDate: {
      required
    }
  },
  methods: {
    showModal() {
      this.value = null;
      this.bookedDate = null;
      this.modalShow = true;
    },
    resetModal() {
      this.value = null;
      this.bookedDate = null;
      this.$v.$reset();
    },
    onSubmit(bvModalEvt) {
      this.$v.$touch();
      bvModalEvt.preventDefault();

      if (!this.$v.$error) {
        axios
          .post("/prepaids", {
            userId: this.userId,
            value: replaceCommasWithDots(this.value),
            bookedDate: this.bookedDate
          })
          .then(() => {
            eventBus.$emit("notify-success", "Dodano nową przedpłatę");
            this.$emit("prepaid-added");
            this.modalShow = false;
          })
          .catch(error => eventBus.$emit("unhandled-error", error));
      }
    },
    onlyForCurrency($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      let valueString = this.value + "";
      valueString = replaceCommasWithDots(valueString);

      // only allow number and one comma
      if (
        (keyCode < 48 || keyCode > 57) &&
        (keyCode !== 44 || valueString.indexOf(".") != -1)
      ) {
        // 46 is dot, 44 is comma
        $event.preventDefault();
      }

      if (
        $event.target.selectionStart > valueString.indexOf(".") &&
        valueString.indexOf(".") != -1
      ) {
        if (
          this.value != null &&
          valueString.indexOf(".") > -1 &&
          valueString.split(".")[1].length > 1
        ) {
          $event.preventDefault();
        }
      }

      if ($event.target.selectionStart == 0 && $event.key == 0) {
        $event.preventDefault();
      }
    }
  },
  props: {
    userId: String
  }
};
</script>

<style lang="scss" scoped>
</style>